export const HelpScoutArticleKey = {
  PASSKEY_MIGRATION: "passkeyMigration",
  PASSKEY_VS_WALLET: "passkeyVsWallet",
  CONFIDENTIAL_MODE: "confidentialMode",
  CONFIDENTIAL_HISTORY: "confidentialHistory",
  AFFILIATE_TERMS: "affiliateTerms",
} as const

export type HelpScoutArticleKey =
  (typeof HelpScoutArticleKey)[keyof typeof HelpScoutArticleKey]

export type HelpScoutArticle =
  | { published: true; articleId: string; title: string }
  | { published: false; title: string }

export const helpScoutArticles: Record<HelpScoutArticleKey, HelpScoutArticle> =
  {
    [HelpScoutArticleKey.PASSKEY_MIGRATION]: {
      published: true,
      articleId: "69a024a52be6f4d39503a4d8",
      title: "Passkey migration from near-intents.org to near.com",
    },
    [HelpScoutArticleKey.PASSKEY_VS_WALLET]: {
      published: true,
      articleId: "69a04fc140fe578dafbb0898",
      title: "Passkey vs. Web3 wallet — choosing how to sign in",
    },
    [HelpScoutArticleKey.CONFIDENTIAL_MODE]: {
      published: true,
      articleId: "69a0500440fe578dafbb08ad",
      title: "Confidential mode",
    },
    [HelpScoutArticleKey.CONFIDENTIAL_HISTORY]: {
      published: false,
      title: "Confidential history",
    },
    [HelpScoutArticleKey.AFFILIATE_TERMS]: {
      published: true,
      articleId: "6a27f1703bec0a47c135d06f",
      title: "Referrals & Affiliate Program Agreement",
    },
  }

export function openHelpScoutArticle(key: HelpScoutArticleKey): void {
  const article = helpScoutArticles[key]
  if (!article.published) return
  if (typeof window === "undefined" || !window.Beacon) return
  window.Beacon("article", article.articleId)
}
